import axios from "axios";
import { apiUrl } from "../constant";

const getWalletThresholdDefaults = () => {
    return axios.get(`${apiUrl}/api/DefaultConfig/WalletThresholdDefaults`);
};

const updateWalletThresholdDefaults = (data) => {
    return axios.put(`${apiUrl}/api/DefaultConfig/WalletThresholdDefaults`, data);
};

const getConfigurationDefaults = () => {
    return axios.get(`${apiUrl}/api/DefaultConfig/ConfigurationDefaults`);
};

const updateConfigurationDefaults = (data) => {
    return axios.put(`${apiUrl}/api/DefaultConfig/ConfigurationDefaults`, data);
};

export const defaultConfigService = {
    getWalletThresholdDefaults,
    updateWalletThresholdDefaults,
    getConfigurationDefaults,
    updateConfigurationDefaults,
};
